import React from 'react'
import List from '@material-ui/core/List'
import PeopleAltOutlinedIcon from '@material-ui/icons/PeopleAltOutlined'
import AssignmentTurnedInTwoToneIcon from '@material-ui/icons/AssignmentTurnedInTwoTone'
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn'
import PersonIcon from '@material-ui/icons/Person'
import EditIcon from '@material-ui/icons/Edit'
import { renderMenuItem } from '../../layout/Menu'
import { useTranslation } from 'react-i18next'

const PatientSelectPageMenu = () => {
  const { t } = useTranslation('patientSelectPage')

  // Create a composite icon for "person with edit" for co-practitioner section
  const PersonWithEditIcon = () => (
    <div style={{ position: 'relative', display: 'inline-block' }}>
      <PersonIcon />
      <EditIcon style={{ 
        position: 'absolute', 
        bottom: 3, 
        right: 1, 
        fontSize: '12px',
        background: 'white',
        borderRadius: '50%'
      }} />
    </div>
  )

  return (
    <List>
      {renderMenuItem(
        t('caseloadSectionTitle'),
        'caseload-section',
        PeopleAltOutlinedIcon
      )}
      {renderMenuItem(
        t('completedTreatmentsSectionTitle'),
        'completed-treatments-section',
        AssignmentTurnedInIcon
      )}
      {renderMenuItem(
        t('coPractitionerSectionTitle'),
        'co-practitioner-section',
        PersonWithEditIcon
      )}
      {renderMenuItem(
        t('completedCoPractitionerSectionTitle'),
        'completed-co-practitioner-section',
        AssignmentTurnedInTwoToneIcon
      )}
    </List>
  )
}

export default PatientSelectPageMenu
